import { DEFAULTS } from "../defaults";
import {
  cleanPhone,
  makeEmptyLosses,
  normalizeCompanyGaragingAddress,
  normalizeCompanyMailingAddress
} from './helpers'

export function mapCompanyToDefaults(company) {
  return {
    ...DEFAULTS,

    step1: {
      policyDate: new Date(),
      carrier: [],
      insuredWithProgressiveCommercialAuto: "na",
      hazmatPlacard: false,
      haulDoubleTripleTrailers: false,
      operatedTwoYears: "na",
      personalUseOfTrailer: false,
      personalUseOfVehicle: false,
    },

    step2: {
      carrier: [],
      dot: {
        hasUsdot: company.dot_number ? "yes" : "no",
        dotNumber: company.dot_number ? Number(company.dot_number) : undefined,
      },
      hasLossRuns: "na",
      insuredIssuedWithInLastSixtyDays: "na",
      insuredName: company.name ?? "",
      dba: company.dba ?? "",
      mailingAddress: normalizeCompanyMailingAddress(company),
      garagingAddress: normalizeCompanyGaragingAddress(company),
      garagingSameAsMailing: false,
      insuredContact: {
        firstName: company.contact?.first ?? "",
        lastName: company.contact?.last ?? "",
        email: company.contact?.email ?? "",
        phone: cleanPhone(company.contact?.phone || company?.phone || ""),
      },
      owner: company.ownerName
        ? {
            firstName: company.ownerName.split(" ")[0] ?? "",
            lastName:
              company.ownerName.split(" ").slice(1).join(" ") || "",
          }
        : undefined,
    },

    step3: {
      priorCancelled: false,
      cancellations12mo: false,
      uiiaIntermodal: false,
      filingsAlFederal: false,
      filingsAlState: false,
      dumpLoadsTarped: false,
      freeBoardSixInches: false,
      roadsideConstruction: false,
      operatingStart: { year: "", month: "" },
      entityType: undefined,
      business_description: [],
      hasIneligibleOps: false,
      operationDescription: "",
      noneOfMentioned: false,
    },

    step4: { carrier: [], telemetryOption: undefined, telemetryProvider: undefined },

    step5: { ...DEFAULTS.step5, drivers: [] },
    step6: { ...DEFAULTS.step6, carrier: [], personalUse: false, vehicles: [] },
    step7: { carrier: [], trailers: [], nbrOfTrailers: 0, valueOfTrailers: 0 },
    step8: { carrier: [], commodity_array: [], stateOperation: "interstate" },
    step9: { losses: makeEmptyLosses() },
  };
}
